import { atom } from 'jotai'

export const oneTrustConsentAtom = atom(false)

/**
 * Tracks whether OneTrust has finished loading and consent has been evaluated
 * at least once. Consumers that need to distinguish "consent is false" from
 * "consent not yet determined" (e.g. deep-link resolvers that would otherwise
 * fire a spurious failure on the initial render) can gate on this atom.
 */
export const oneTrustConsentLoadedAtom = atom(false)
